// extracted by mini-css-extract-plugin
export default {"wrapper":"Main_wrapper__tkbni","card":"Main_card__i7X07","testName":"Main_testName__V-plR","option":"Main_option__FnmP5","length":"Main_length__b8QNa"};